<template>
  <div
    class="text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:border-gray mb-8"
  >
    <ul class="flex flex-wrap list-none !m-0">
      <li
        v-for="(tab, index) in tabs"
        :key="index"
        class="me-2"
      >
        <RouterLink
          class="px-5 md:px-8"
          :class="[
            selectedIndex === index ? 'inline-block p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500' : '',
            selectedIndex !== index ? 'text-gray-dark inline-block p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-secondary dark:hover:text-secondary' : '',
          ]"
          :to="{ name: tab.routeName }"
          replace
          @click="selectedIndex = index"
        >
          {{ tab.heading }}
        </RouterLink>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

const tabs = [
  { heading: 'Overview', routeName: 'app_admin_event_show_overview' },
  { heading: 'Metadata', routeName: 'app_admin_event_show_metadata' },
  { heading: 'Prices', routeName: 'app_admin_event_show_prices' },
  { heading: 'Photos', routeName: 'app_admin_event_show_photos' },
  { heading: 'Report', routeName: 'app_admin_event_show_report' },
];

const route = useRoute();
const selectedIndex = ref(0);

// This is a necessary watcher because when you move to this route from another route on the website it will use the old route
watch(() => route.name, (newRouteName) => {
  selectedIndex.value = tabs.findIndex(tabRoute => tabRoute.routeName === newRouteName);
}, { immediate: true });

</script>
